<div class="row mt-3">
  <div class="col-sm-10">
    <div class="input-group justify-content-end align-items-center">
      <div class="d-flex justify-content-center align-items-center" style="margin: 0;">
        <label class="vid-label-sm me-2 mb-0"></label>
        <input placeholder="Search" type="text" maxlength="50" class="no-caret form-control ms-2" [(ngModel)]="q"
               (keydown.enter)="loadApplicationsFromSearch()" style="height: 28px;">
      </div>
      <button id="search_button" (click)="loadApplicationsFromSearch()" class="vid-btn vid-btn-sm ms-2">Search</button>
    </div>
  </div>
  <div class="col-sm-10">
    <div class="vid-main-content">
      <div class="row mb-4">
        <div class="col-sm-12">
          <div *ngIf="serviceProviderApplications.length === 0" class="alert alert-info" role="alert">
            The list is empty.
          </div>

          <div class="row">
            <div *ngFor="let app of serviceProviderApplications"  class="col-md-3 col-sm-6 mb-3">
              <div class="box">
                <app-card [name] ="app.name"
                          [description] = "app.friendlyName"
                          [redirectUrl]="app.redirectUrl"
                          [logoFile]="app.logoFile"
                          class="card-container">
                </app-card>
                <div class="ribbon-wrapper">
                  <div [ngClass]="app.type=='saml' ? 'ribbon-saml':'ribbon-oidc '">{{app.type.toUpperCase()}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-2">
    <div class="vid-right-side-menu vid-side-menu-no-top">
      <div class="mb-2 p-2">
        <span class="section-title">{{ 'APPLICATIONS.HELP' | translate }}</span>
        <div class="settings-activity">
          <div class="m-2 alert alert-secondary vid-list-item-description" role="alert">
            {{ 'APPLICATIONS.HELP_ABOUT' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
